import React, { useState, useEffect } from "react";
import "./Leaves.scss";
import { useNavigate } from "react-router-dom";
import API from "api/endpoints";
import { Card, Empty, Tag, Button, Table, Typography } from "antd";
import axiosInstance from "api/axiosInstance";
import { LeaveTypeEnumLabel } from "Constants/Enums/LeavePolicyEnum";

const { Text } = Typography;

function Leaves() {
  const navigate = useNavigate();
  const [leaveData, setLeaveData] = useState([]);
  const [loading, setLoading] = useState(false);
  const employeeEmail = localStorage.getItem("email");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(API.leaveRequest.myRequests);
        setLeaveData(response.data);
      } catch (error) {
        console.error("Error fetching leave data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (employeeEmail) {
      fetchData();
    }
  }, [employeeEmail]);

  const requestTimeOff = () => {
    navigate("/employeedashboard/emprequestTimeOff");
  };

  const navigateToLeaveRequests = () => {
    navigate("/employeedashboard/leave-request");
  };

  // Get status tag color and text
  const getStatusTag = (status) => {
    const statusConfig = {
      0: { color: "orange", text: "Pending" },
      1: { color: "green", text: "Approved" },
      2: { color: "red", text: "Rejected" },
    };

    const config = statusConfig[status] || { color: "default", text: "Unknown" };
    return <Tag color={config.color}>{config.text}</Tag>;
  };

  // Format date
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };

  // Table columns for leave requests
  const requestColumns = [
    {
      title: "Policy",
      dataIndex: ["leavePolicy", "policyName"],
      key: "policyName",
      render: (text, record) => (
        <div>
          <Text strong>{text}</Text>
          <br />
          <Tag size="small">{LeaveTypeEnumLabel[record.leaveType] || "Unknown"}</Tag>
        </div>
      ),
    },
    {
      title: "Dates",
      dataIndex: "fromDate",
      key: "dates",
      render: (fromDate, record) => (
        <div>
          <Text>
            {formatDate(fromDate)} to {formatDate(record.toDate)}
          </Text>
          <br />
          <Text type="secondary">{record.totalDays} days</Text>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => getStatusTag(status),
    },
    {
      title: "Applied On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (date) => formatDate(date),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      ellipsis: true,
    },
    {
      title: "Remarks",
      dataIndex: "reviewerRemarks",
      key: "reviewerRemarks",
      render: (remarks) => remarks || "-",
      ellipsis: true,
    },
  ];

  return (
    <Card title="My Leave Requests" loading={loading} className="card-professional">
      {leaveData.length === 0 ? (
        <Empty description="No leave requests found">
                     <Button className="btn-primary" onClick={navigateToLeaveRequests}>
              Apply for Leave Request
            </Button>
        </Empty>
      ) : (
        <>
          <Table
            columns={requestColumns}
            dataSource={leaveData}
            rowKey="id"
            pagination={{
              pageSize: 5,
              showSizeChanger: false,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} requests`,
            }}
            locale={{
              emptyText: "No leave requests found",
            }}
            onRow={(record) => {
              return {
                             };
            }}
          />

          {/* Summary Stats */}
          {leaveData.length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 16,
                padding: "16px",
                background: "#fafafa",
                borderRadius: "6px",
              }}
            >
              <div>
                <div style={{ fontSize: "12px", color: "#666" }}>Total Requests</div>
                <div style={{ fontSize: "16px", fontWeight: "bold" }}>{leaveData.length}</div>
              </div>
              <div>
                <div style={{ fontSize: "12px", color: "#666" }}>Pending</div>
                <div style={{ fontSize: "16px", fontWeight: "bold", color: "#fa8c16" }}>
                  {leaveData.filter((req) => req.status === 0).length}
                </div>
              </div>
              <div>
                <div style={{ fontSize: "12px", color: "#666" }}>Approved</div>
                <div style={{ fontSize: "16px", fontWeight: "bold", color: "#52c41a" }}>
                  {leaveData.filter((req) => req.status === 1).length}
                </div>
              </div>
              <div>
                <div style={{ fontSize: "12px", color: "#666" }}>Rejected</div>
                <div style={{ fontSize: "16px", fontWeight: "bold", color: "#ff4d4f" }}>
                  {leaveData.filter((req) => req.status === 2).length}
                </div>
              </div>
            </div>
          )}

          {/* View More Button */}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "16px",
            }}
          >
            <Button className="btn-primary" onClick={navigateToLeaveRequests}>
              Apply for Leave Request
            </Button>
          </div>
        </>
      )}
    </Card>
  );
}

export default Leaves;
